import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { DatePicker as AntdDatePicker, Picker } from 'components/atoms/date-picker';
import { getBackgroundColor, NewInputBorder, NewInputFocus } from 'components/atoms/input/input';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
// Rocketlane UI styled component with new design
export const RocketlaneUIDatePicker = styled(Picker)`
  background-color: ${getBackgroundColor(true)};
  ${NewInputBorder};
  padding: 0 var(--spacing-05);
  height: var(--input-size-sm);
  &:hover {
    border-color: var(--gray-20);
  }
  &.ant-picker-disabled {
    opacity: 0.5;
  }
  &.ant-picker-focused {
    ${NewInputFocus};
  }
`;
const DatePickerComponent = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const isNewDesignEnabled = useAntdRlUISwitcher();
    if (isNewDesignEnabled) {
        const { className, ...restProps } = props;
        return /*#__PURE__*/ _jsx(RocketlaneUIDatePicker, {
            ...restProps,
            ref: ref,
            className: `rl-date-field${className ? ` ${className}` : ''}`
        });
    }
    return /*#__PURE__*/ _jsx(AntdDatePicker, {
        ...props,
        ref: ref
    });
});
DatePickerComponent.displayName = 'DatePicker';
// Wrap in styled() so it can be used as ${DatePicker} in styled-component interpolations
export const DatePicker = styled(DatePickerComponent)``;
DatePicker.displayName = 'DatePicker';
